import { Fragment } from 'react';

import PropTypes from 'prop-types';

import Button, { ButtonAppearance, ButtonIconPosition, ButtonKind } from 'bloko/blocks/button';
import FormSpacer from 'bloko/blocks/form/FormSpacer';
import Gap from 'bloko/blocks/gap';
import { H2Section } from 'bloko/blocks/header';
import Icon, { IconScale, IconView } from 'bloko/blocks/icon';

import useTrls from 'hooks/translation/useTrls';

import AdminFilterWrapper from 'components/Filter';

import Spinner from 'components/Admin/Spinner';

const ReportWrapper = ({ title, filter, content, isLoadContent, onClickSearch, onClickClear, onClickCSV }) => {
    const trl = useTrls();

    return (
        <Fragment>
            {title && <H2Section lite>{title}</H2Section>}
            <Gap top bottom>
                <AdminFilterWrapper
                    settings={filter}
                    actions={
                        <Fragment>
                            {onClickCSV && (
                                <Button
                                    appearance={ButtonAppearance.Outlined}
                                    onClick={onClickCSV}
                                    icon={<Icon view={IconView.ArrowLine} scale={IconScale.Small} />}
                                    iconPosition={ButtonIconPosition.Left}
                                >
                                    {trl('admin.report.action.csv')}
                                </Button>
                            )}
                            {onClickClear && (
                                <Button appearance={ButtonAppearance.Outlined} onClick={onClickClear}>
                                    {trl('admin.report.action.clear')}
                                </Button>
                            )}
                            {onClickSearch && (
                                <FormSpacer>
                                    <Button onClick={onClickSearch} kind={ButtonKind.Primary}>
                                        {trl('admin.report.action.search')}
                                    </Button>
                                </FormSpacer>
                            )}
                        </Fragment>
                    }
                />
            </Gap>
            {isLoadContent ? <Spinner /> : content}
        </Fragment>
    );
};

ReportWrapper.propTypes = {
    title: PropTypes.string,
    filter: PropTypes.node.isRequired,
    content: PropTypes.node.isRequired,
    isLoadContent: PropTypes.bool.isRequired,
    onClickSearch: PropTypes.func.isRequired,
    onClickClear: PropTypes.func,
    onClickCSV: PropTypes.func,
};

export default ReportWrapper;
